import { BonusCondition, GenericObject } from '@synergy/models';
import { Media, copyFields, fixDates } from '@synergy/models';

import { Account } from './account';
import { Contact } from './contact';
import { OfferCompleteStatus } from './enums/offer-complete-status';
import { OfferItem } from './offer-item';
import { OfferStatus } from './enums/offer-status';
import { PaymentTerm } from './payment-term';
import { User } from './user';

export class Offer {
    public id!: number;
    public status!: OfferStatus;
    public completeStatus!: OfferCompleteStatus;
    public deliveryPrice!: number;
    public surcharge!: number;
    public discount!: number;
    public supplierAccount!: Account;
    public supplierContact?: Contact;
    public isRecommended!: boolean;
    public internalNote?: string;
    public noteFromSupplier?: string;
    public media!: Media[];
    public offerItems!: OfferItem[];
    public accountPurchaseId?: number;
    public offerSubmittedBy?: Contact;
    public emailSentDate?: Date;
    public createdAt?: Date;
    public createdBy?: User;
    public updatedAt?: Date;
    public updatedBy?: User;
    public termsOfDeliveryContent?: string;
    public supplierBonus?: string;
    public supplierDeclinedReason?: string;
    public paymentTerm!: PaymentTerm;
    public supplierBonusConditions?: BonusCondition[];
    public supplierOfferNumber?: string;

    public static fromPlainObject(object: GenericObject): Offer {
        const offer = new Offer();

        copyFields(object, offer);

        if (object['supplierAccount']) {
            offer.supplierAccount = Account.fromPlainObject(object['supplierAccount']);
        }

        if (object['createdBy']) {
            offer.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            offer.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        if (object['supplierContact']) {
            offer.supplierContact = Contact.fromPlainObject(object['supplierContact']);
        }

        if (object['offerSubmittedBy']) {
            offer.offerSubmittedBy = Contact.fromPlainObject(object['offerSubmittedBy']);
        }

        if (object['offerItems']) {
            offer.offerItems = object['offerItems'].map(OfferItem.fromPlainObject);
        }

        if (object['media']) {
            offer.media = object['media'].map(Media.fromPlainObject);
        }

        fixDates(offer, ['createdAt', 'updatedAt', 'emailSentDate']);

        return offer;
    }

    public getTotal(): number {
        const totalSum =
            (this.offerItems.reduce(
                (total, offerItem) =>
                    offerItem.isOffered || offerItem.isAlternative
                        ? total + (offerItem.price || 0) * offerItem.quantity
                        : total,
                0
            ) *
                (100 - (this.discount || 0))) /
            100;
        return totalSum;
    }

    public getTotalWithCosts(): number {
        return this.getTotal() + (this.deliveryPrice || 0) + (this.surcharge || 0);
    }
}
